import React, { useEffect, useState } from "react";
import { ApprovalsSplashScreen } from "./ApprovalsSplashScreen";
import { Approvals } from "./Approvals";
import styled from "@emotion/styled";
import { AnimatePresence, motion } from "framer-motion";
import { ApprovalStore } from "../../../../store/approvals/ApprovalsStore";
import { EnableSpending } from "./EnableSpending";
import { ApprovalsDoneScreen } from "./ApprovalsDoneScreen";

export const ApprovalsContainer: React.FC = () => {
  const [showSplash, setShowSplash] = useState(true);
  const [isDone, setIsDone] = useState(false);
  const isSignatureOnly = ApprovalStore.useState(s => {
    return (
      (s.tokensByFlow.approve.length === 0 && s.tokensByFlow.revoke.length === 0) ||
      s.permitType === "permit1"
    );
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSplash(false);
    }, 2500);

    return () => clearTimeout(timer); // Cleanup the timer
  }, []);

  return (
    <AnimatePresence initial={false} custom={1} mode={"wait"}>
      {showSplash && (
        <MotionContainer key={1} variants={variants} initial="enter" animate="center" exit="exit">
          <ApprovalsSplashScreen />
        </MotionContainer>
      )}
      {!showSplash && !isSignatureOnly && !isDone && (
        <MotionContainer key={2} variants={variants} initial="enter" animate="center" exit="exit">
          <Approvals
            onDone={() => {
              setIsDone(true);
            }}
          />
        </MotionContainer>
      )}
      {!showSplash && isSignatureOnly && !isDone && (
        <MotionContainer key={3} variants={variants} initial="enter" animate="center" exit="exit">
          <EnableSpending
            onDone={() => {
              setIsDone(true);
            }}
          />
        </MotionContainer>
      )}
      {isDone && (
        <MotionContainer key={4} variants={variants} initial="enter" animate="center" exit="exit">
          <ApprovalsDoneScreen />
        </MotionContainer>
      )}
    </AnimatePresence>
  );
};

const MotionContainer = styled(motion.div)`
  width: 100%;
`;

// Helpers

const variants = {
  enter: (direction: number) => {
    return {
      x: direction > 0 ? -50 : 50,
      opacity: 0,
    };
  },
  center: {
    zIndex: 100000,
    x: 0,
    opacity: 1,
  },
  exit: {
    zIndex: 0,
    opacity: 0,
  },
};
